import terminalService from '@/api/terminal';

export default {
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getAll(params) {
    return terminalService
      .Api()
      .get('timeClock', { params })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  /**
   * ClockIn  timeClock template
   * @param {*} id timeClock id
   * @param {*} data The new data the timeClock will contain
   */
  clockIn(data) {
    return terminalService
      .Api()
      .post('timeClock/clockin', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  restrictiveTime(data) {
    return terminalService
      .Api()
      .post('timeClock/AllClockOut', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  create(data) {
    return terminalService
      .Api()
      .post('timeClock', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  clockOut(data) {
    console.log('data', data)
    return terminalService
      .Api()
      .put('timeClock/clockout', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  clockOutAll(data) {
    return terminalService
      .Api()
      .post('timeClock/clockoutall', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  clockedOutEmployeeList(data) {
    return terminalService
      .Api()
      .get('timeClock/clockedoutEmployees', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  clockedInEmployeeList(data) {
    return terminalService
      .Api()
      .get('timeClock/clockedInEmployees', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  getEmployees(params) {
    return terminalService
      .Api()
      .get('timeClock/employees', { params })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  getEmployeeTimeClock(EmployeeId, params = {}) {
    return terminalService
      .Api()
      .get(`timeClock/employee/${EmployeeId}`, { params })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  getEmployeeTimeClockReport(params = {}) {
    return terminalService
      .Api()
      .get('timeClock/employee/report', { params })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  /**
   * Update specific timeClock
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return terminalService
      .Api()
      .put(`timeClock/${id}`, data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  /**
   * Delete specific timeClock
   * @param {*} id
   */
  delete(id) {
    return terminalService
      .Api()
      .delete(`timeClock/${id}`)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
};
